import Stickynode from 'react-stickynode';
import { isMobile } from 'react-device-detect';
import styles from './ProjectsAside.module.scss';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const ProjectsAside = () => {
  const projectsList = useSelector((state) => state.projects.projects);

  return (
    <aside className={styles.aside}>
      {isMobile ? (
        <div>mobile</div>
      ) : (
        <Stickynode disable={isMobile} top={100}>
          <ul className={styles.list}>
            {projectsList.map((item) => {
              return (
                <li key={item.id} className={styles.item}>
                  <Link to={'/projects/' + item.id} className={styles.link}>
                    <span className={styles.name}>{item.name}</span>
                    <span className={styles.image}>
                      <img src={item.cover} alt="" />
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </Stickynode>
      )}
    </aside>
  );
};

export default ProjectsAside;
